import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
// import Typography from '@material-ui/core/Typography';
// import ErrorIcon from '@material-ui/icons/Error';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { usePermission } from 'Auth/permission-context';
import RightSlide from 'HR/Timeoff/Drawer';
import HelpAndLearn from 'Info/HelpAndLearn';
import { clearAllNotification, getUnreadCount } from 'api/notifications';
import AppsIcon from 'common/images/AppsActive.svg';
import Apps_Icon from 'common/images/Apps_inactive.svg';
import Home_Icon from 'common/images/Home2.svg';
import NotificationsIcon from 'common/images/Notification.svg';
import HomeFill_Icon from 'common/images/Subtract.svg';
import defaultUser from 'common/images/avatar.jpeg';
import Line from 'common/images/divider.svg';
import { useBusinessDetail } from 'context/Business-context';
// import useBillingControl from '../../hooks/useBilling';
import TopNavDrawer from './Drawer';
import LaunchPad from './LaunchPad';
import Notification from './Notification';
import { useStyles } from './styled.top-nav';
import TopUserPopper from './TopUserPopper';

import TopModulesPopper from './TopModulesPopper';
import { Stack } from '@mui/material';
import supportIcon from 'common/images/Support_icon.svg';
import { useAuth } from 'Auth/auth-context';

function TopNav({ toggleWidth, hide }) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { data: BusinessName, queryClient } = useBusinessDetail();
  const { data: userData } = useAuth();
  const { data: unreadCount } = useQuery('unread_count', getUnreadCount);
  const { data: user, isSuccess } = usePermission();
  // const [state, setState] = useBillingControl();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openSideDrawer, setOpenSideDrawer] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openNotif, setOpenNotif] = useState(false);

  useEffect(() => {
    localStorage.setItem('logo', BusinessName?.logo);
  }, [BusinessName]);

  const business_domain = localStorage.getItem('business_domain');

  const readAllMutation = useMutation(clearAllNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries('unread_count');
    }
  });

  const clearAll = () => {
    readAllMutation.mutateAsync().then((res) => res);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseUser = () => {
    setAnchorElUser(null);
  };

  const toggleOpenInfo = () => {
    setOpenInfo(!openInfo);
  };

  const toggleOpenNotif = () => {
    setOpenNotif(!openNotif);
  };
  const open = Boolean(anchorEl);

  const openUser = Boolean(anchorElUser);
  // const isMobile = useMediaQuery({
  //   query: '(max-width: 640px)'
  // });
  const handleLogoutUser = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('business_domain');
    localStorage.removeItem('user');
    localStorage.removeItem('banner');
    window.location.href = '/login';
    // <Redirect to='/login' />;
  };

  const handleSettings = () => {
    history.push('/settings?tab=company-info');
  };

  const handleBilling = () => {
    history.push('/billing?tab=plan');
  };

  // const handleViewCompany = () => {
  //   history.push('/profile?tab=personal-info');
  // };

  // const handleChangeRoute = (path) => {
  //   const accessLevels = [
  //     // '/hr?type=all-employees&tab=all-employee-home',
  //     '/payroll?tab=home'
  //   ];
  //   if (
  //     data.business.billing.plan === 'free' &&
  //     data.business.billing.can_start_free_trial &&
  //     accessLevels.includes(path)
  //   ) {
  //     setState({ ...state, isUpgrade: true });
  //     handleClose();
  //     // setIsUpgradePlan(true);
  //   } else if (
  //     data.business.billing.plan === 'free' &&
  //     data.business.billing.show_expiry_notice &&
  //     accessLevels.includes(path)
  //   ) {
  //     setState({ ...state, isExpiry: true });
  //     // setIsExpiryNotice(true);
  //   } else if (
  //     data.business.billing.plan === 'free' &&
  //     accessLevels.includes(path)
  //   ) {
  //     setState({ ...state, isExpiry: true });
  //     // setIsExpiryNotice(true);
  //   } else {
  //     // history.push(path);
  //     window.open(path, '_blank');
  //     // !banner && localStorage.setItem('banner', true);
  //   }
  // };

  const topUserPopperProps = {
    classes,
    openUser,
    anchorElUser,
    handleCloseUser,
    BusinessName,
    user,
    handleSettings,
    handleBilling,
    handleLogoutUser
  };

  const topModulePopperProps = {
    classes,
    isSuccess,
    data: user,
    open,
    anchorEl,
    handleClose,
    user
  };

  const navs = [
    {
      name: 'Home',
      icon: location.pathname === '/dashboard' ? HomeFill_Icon : Home_Icon,
      alt: 'home icon',
      imgStyle: { width: '23px', height: '27px' },
      isActive: location.pathname === '/dashboard',
      onClick: () => {
        history.push('/dashboard');
      },
      id: 'home'
    },
    {
      name: 'Apps',
      icon: location.pathname !== '/dashboard' ? AppsIcon : Apps_Icon,
      alt: 'apps icon',
      imgStyle: { width: '23px', height: '27px' },
      onClick: handleClick,
      isActive: location.pathname !== '/dashboard',
      id: 'apps'
    },
    {
      name: 'Support & Info',
      icon: supportIcon,
      alt: 'support & info icon',
      imgStyle: { width: '26px', height: '27px' },
      onClick: toggleOpenInfo,
      id: 'support_info'
    },
    {
      name: 'Notification',
      icon: NotificationsIcon,
      alt: 'notification icon',
      imgStyle: { width: '23px', height: '23px' },
      onClick: toggleOpenNotif,
      id: 'notification'
    }
  ];

  return (
    <Wrapper hide={hide}>
      {/* Todo: change justify to space-between */}

      <TopNavDrawer
        state={openSideDrawer}
        setState={setOpenSideDrawer}
        data={userData}
        BusinessName={BusinessName}
        user={user}
        ctaClass={classes.cta}
      />
      <RightSlide
        state={openInfo}
        setState={setOpenInfo}
        className='side-drawer3'
      >
        <HelpAndLearn state={openInfo} setState={setOpenInfo} />
      </RightSlide>
      <RightSlide
        state={openNotif}
        setState={setOpenNotif}
        className='side-drawer2'
      >
        <Notification closeModal={() => setOpenNotif(false)} />
        {/* {stages[stage]} */}
      </RightSlide>
      <Box
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        className='nav-top'
      >
        {/* Navigation hidden for specific business */}
        {business_domain === 'd741f131-55ff-4a11-b0b2-14e0c0ac10bb' && (
          <Box
            style={{
              // background: '#ffffff55',
              height: '80px',
              width: '100vw',
              position: 'absolute',
              zIndex: '100000',
              top: 0,
              left: 0
            }}
          ></Box>
        )}
        <Box
          display='flex'
          alignItems={'center'}
          style={{ width: '40%', gap: 10, cursor: 'pointer' }}
        >
          <img
            src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638786088/Bizedge_Frontend_Assets/Bizedge_logo_axcwlg.svg'
            alt='bizedge logo'
            style={{ width: '100px' }}
            onClick={() => history.push('/dashboard')}
          />
          <div className='as' id='launchpad'>
            <LaunchPad data={user} />
          </div>
        </Box>
        <Stack
          maxWidth={'500px'}
          width='35%'
          direction={'row'}
          gap='1.5rem'
          alignItems={'ceneter'}
          justifyContent={'flex-end'}
        >
          <Stack direction='row' gap={'45px'} alignItems={'center'}>
            {/* {!isMobile && ( */}
            {navs?.map((nav) => (
              <Box
                style={{
                  cursor: 'pointer',
                  color: nav?.isActive ? '#2898A4' : '#545454'
                }}
                onClick={nav.onClick}
              >
                {nav.id === navs[3].id ? (
                  <Badge
                    badgeContent={unreadCount?.count}
                    color='secondary'
                    onClick={clearAll}
                  >
                    <img src={nav.icon} alt={nav.alt} style={nav.imgStyle} />
                  </Badge>
                ) : (
                  <img src={nav.icon} alt={nav.alt} style={nav.imgStyle} />
                )}
              </Box>
            ))}
          </Stack>

          <Stack direction='row' gap='1rem' alignItems={'center'}>
            <Box>
              <img src={Line} alt='' />
            </Box>
            {/* )} */}
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={() => setOpenSideDrawer(true)}
              className='mobile-profile'
            >
              <Avatar
                alt='business logo'
                src={
                  BusinessName && BusinessName.logo !== null
                    ? BusinessName.logo
                    : defaultUser
                }
                className={classes.small}
                id='profile'
              />
              <KeyboardArrowDownRoundedIcon />
            </Box>
          </Stack>
        </Stack>
      </Box>
      <TopModulesPopper {...topModulePopperProps} />
      <TopUserPopper {...topUserPopperProps} />
    </Wrapper>
  );
}

export default TopNav;

const Wrapper = styled(Box)`
  ${({ theme, hide }) => `
  position: fixed;
  display: ${hide === 'true' ? 'none' : 'flex'};
  // border: 1px solid green;
  // z-index: 4;
  // border-bottom: 1px solid #F2F2F2;
  box-shadow: 0px 6px 6px rgba(215, 215, 215, 0.15);
  padding: .8em 2em;
  // padding: 15px 150px;
  // margin-bottom: 1em;
  z-index: 8;
  width: 100%;
  background: white;
  `}
  .business_name {
    font-weight: 600;
    font-size: 20px;
    line-height: 128.86%;
  }
`;

// const Image = styled.img`
//   max-height: 43px;
//   max-width: 40px;
//   border-radius: 50%;
//   display: block;
// `;
